var React = require('react');

function CaretRight (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#FFD301","key":0}),React.createElement("path",{"d":"M12.6084 7.35179C12.3389 7.62136 12.1875 7.98693 12.1875 8.3681C12.1875 8.74927 12.3389 9.11484 12.6084 9.38441L19.724 16.5L12.6084 23.6157C12.3465 23.8868 12.2016 24.2499 12.2049 24.6268C12.2082 25.0037 12.3594 25.3643 12.6259 25.6308C12.8924 25.8973 13.253 26.0485 13.6299 26.0518C14.0068 26.055 14.3699 25.9101 14.641 25.6483L22.7729 17.5163C23.0424 17.2468 23.1938 16.8812 23.1938 16.5C23.1938 16.1189 23.0424 15.7533 22.7729 15.4837L14.641 7.35179C14.3714 7.0823 14.0059 6.93091 13.6247 6.93091C13.2435 6.93091 12.878 7.0823 12.6084 7.35179V7.35179Z","fill":"white","key":1})]);
}

CaretRight.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CaretRight;

CaretRight.default = CaretRight;
